import { classNames } from "../../../Utils/classNames/classNames";
import cls from "./Overlay.module.css";

interface OverlayProps {
    className?: string;
    onClick?: () => void;
    clear?: boolean;
}
export const Overlay = (props: OverlayProps) => {
    const { className, onClick, clear } = props;

    return <div onClick={onClick} className={classNames(cls.overlay, { [cls.clear]: clear }, [className])} />;
};
